import { PlusCircleOutlined } from "@ant-design/icons";

import { RVButton, RVFormItem, RVCollapse } from "@regal-voice/ui";

type LayoutProps = {
    panelsList: any;
    activeKey: number[];
    addPanel: () => void;
};

const PANEL_TITLE = "Update Contact Attributes";
const BUTTON_TEXT = "Add Contact Attribute";

export function UpdateProfilePanelsLayout({ activeKey, addPanel, panelsList }: LayoutProps): JSX.Element {
    return (
        <RVFormItem label={PANEL_TITLE}>
            {!!panelsList.length && <RVCollapse panelsList={panelsList} activeKey={activeKey}></RVCollapse>}
            <RVButton onClick={addPanel} icon={<PlusCircleOutlined />}>
                {BUTTON_TEXT}
            </RVButton>
        </RVFormItem>
    );
}
